import { useCallback, useEffect, useRef } from 'react';

// https://github.com/streamich/react-use/blob/master/docs/useMountedState.md

export default function useIsMounted() {
  const mountedRef = useRef(false);
  const get = useCallback(() => mountedRef.current, []);

  useEffect(() => {
    mountedRef.current = true;

    return () => {
      mountedRef.current = false;
    };
  }, []);

  return get;
}